import { useState, useEffect } from "react";
import { useGetAllTestSeriesQuery } from "src/services/TestSeriesServices";

const useTests = () => {
  const [tests, setBatches] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const { data, isLoading, isFetching } = useGetAllTestSeriesQuery("");
  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setBatches(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);
  return { tests, isDataLoading };
};

export default useTests;
